import React, { useEffect, useState } from "react";
import { getAddressAPI, saveAddressAPI } from "../../../service/cart.service";
import {
  getFormValues,
  validateOnSubmit,
} from "../../../service/validation.service";
import SpinnerComponent from "../../atoms/spinner/spinner.component";
import SimpleFormBuilder from "../../molecules/simple-form-builder/simple-form-builder.component";
import { deleteCustomerAddressAPI } from "../../../service/customer.service";

const addressInputs = (address) => [
  {
    type: "TEXT",
    id: "company_name",
    name: "company_name",
    placeholder: "Company Name",
    class: "col-md-6",
    value: address?.company_name || "",
    validations: [
      {
        type: "REQUIRED",
        message: "Please enter the company name",
      },
    ],
  },
  {
    type: "TEXT",
    id: "gstin_number",
    name: "gstin_number",
    placeholder: "GST Number",
    class: "col-md-6",
    value: address?.gstin_number || "",
    validations: [
      {
        type: "REQUIRED",
        message: "Please enter the gst number",
      },
    ],
  },
  {
    type: "TEXT",
    id: "invoice_to",
    name: "invoice_to",
    placeholder: "Contact Person",
    value: address?.invoice_to || "",
    class: "col-md-6",
    validations: [
      {
        type: "REQUIRED",
        message: "Please enter the contact person",
      },
    ],
  },

  {
    type: "TEXT",
    id: "contact_person_number",
    name: "contact_person_number",
    placeholder: "Contact Person Mobile",
    value: address?.contact_person_number || "",
    class: "col-md-6",
    validations: [
      {
        type: "REQUIRED",
        message: "Please enter the contact person mobile",
      },
    ],
  },

  {
    type: "TEXT",
    id: "address_line1",
    name: "address_line1",
    placeholder: "Address Line 1",
    value: address?.address_line1 || "",
    class: "col-md-12",
    validations: [
      {
        type: "REQUIRED",
        message: "Please enter the address line 1",
      },
    ],
  },

  {
    type: "TEXT",
    id: "address_line2",
    name: "address_line2",
    placeholder: "Address Line 2",
    value: address?.address_line2 || "",
    class: "col-md-12",
    validations: [
      {
        type: "REQUIRED",
        message: "Please enter the address line 2",
      },
    ],
  },

  {
    type: "TEXT",
    id: "city",
    name: "city",
    placeholder: "City",
    value: address?.city || "",
    class: "col-md-6",
    validations: [
      {
        type: "REQUIRED",
        message: "Please enter the city",
      },
    ],
  },

  {
    type: "TEXT",
    id: "state",
    name: "state",
    placeholder: "State",
    value: address?.state || "",
    class: "col-md-6",
    validations: [
      {
        type: "REQUIRED",
        message: "Please enter the state",
      },
    ],
  },

  {
    type: "TEXT",
    id: "pincode",
    name: "pincode",
    placeholder: "Pincode",
    value: address?.pincode || "",
    class: "col-md-6",
    validations: [
      {
        type: "REQUIRED",
        message: "Please enter the pincode",
      },
    ],
  },

  {
    type: "TEXT",
    id: "country",
    name: "country",
    placeholder: "Country",
    class: "col-md-6",
    isDisabled: true,
    value: "India",
  },
];

const BillingDetailsComponent = ({}) => {
  const [address, setAddress] = useState({
    loading: true,
    addBilling: false,
    data: null,
    billingSame: true,
    billing: [],
    shipping: [],
    editingIndex: null,
  });
  const onLoad = async () => {
    const addressResp = await getAddressAPI();

    if (addressResp.status) {
      if (addressResp.data.length === 0) {
        setAddress({ ...address, loading: false, noData: true });
        return;
      }

      const shippingList = addressResp.data.filter(
        (a) => a.type === "shipping"
      );
      const billing = addressResp.data.find((a) => a.type === "billing");

      setAddress({
        ...address,
        loading: false,
        addBilling: false,
        data: true,
        shipping: shippingList,
        billing,
      });
    }
  };

  const handleAddBillingAddress = () => {
    const shippingInputs = addressInputs(address?.shipping || {});
    const billingInputs = addressInputs(address?.billing || {});
    setAddress({
      ...address,
      addBilling: true,
      noData: false,
      data: null,
      // shippingInputs,
      billingInputs,
      shippingInputsList: [shippingInputs],
    });
  };

  const handleSameAsBilling = (e) => {
    console.log("handleSameAsBilling", e.target.checked);
    setAddress({ ...address, billingSame: e.target.checked });
  };

  const handleFormDataChange = (type, data) => {
    console.log({ type, data });
    setAddress({
      ...address,
      [type]: data,
    });
  };

  const handleSaveBilling = async () => {
    const billingErrors = validateOnSubmit(address.billingInputs);
    const shippingErrors = address.shippingInputsList.flatMap((inputs) =>
      validateOnSubmit(inputs)
    );
    if (billingErrors.length > 0 || shippingErrors.length > 0) {
      console.log("Validation errors");
      return;
    }
    // Get the updated shipping addresses
    const updatedShipping = [...(address.shipping || [])];
    const newShippingData = getFormValues(address.shippingInputsList[0]);

    if (address.editingIndex !== null) {
      // Update existing address
      updatedShipping[address.editingIndex] = {
        ...updatedShipping[address.editingIndex],
        ...newShippingData,
      };
    } else {
      // Add new address
      updatedShipping.push(newShippingData);
    }
    const payload = {
      billing: getFormValues(address.billingInputs),
      shipping: updatedShipping,
      same_billing: address.billingSame,
    };
    const saveResp = await saveAddressAPI(payload);
    if (saveResp.status) {
      // Reset form and reload data
      setAddress((prev) => ({
        ...prev,
        loading: true,
        addBilling: false,
        data: null,
        billingInputs: [],
        shippingInputsList: [],
        editingIndex: null,
      }));
      onLoad();
    }
  };

  console.log("add billing", address.addBilling);

  const handleEditAddress = (addressToEdit, index) => {
    return () => {
      setAddress((prev) => ({
        ...prev,
        addBilling: true,
        noData: false,
        data: null,
        shippingInputsList: [addressInputs({ ...addressToEdit })],
        billingInputs: addressInputs(prev.billing || {}),
        billingSame: true,
        editingIndex: index,
      }));
    };
  };

  const handleAddShippingBlock = () => {
    if (!address.addBilling) {
      const shippingInputs = addressInputs({});
      const billingInputs = addressInputs(address?.billing || {});

      setAddress({
        ...address,
        addBilling: true,
        noData: false,
        data: null,
        billingInputs: billingInputs,
        shippingInputsList: [shippingInputs],
        billingSame: true,
        editingIndex: null, 
      });
    } else {
      setAddress((prev) => ({
        ...prev,
        shippingInputsList: [
          ...(prev.shippingInputsList || []),
          addressInputs({}),
        ],
        editingIndex: null, // Reset editing index when adding another new one
      }));
    }
  };

  const handleRemoveShippingBlock = (index) => {
    setAddress((prev) => ({
      ...prev,
      shippingInputsList: prev.shippingInputsList.filter((_, i) => i !== index),
    }));
  };

  const handleDeleteAddress = async (addressId) => {

    const payload = {
      ids: [addressId],
    };
    try {
      const response = await deleteCustomerAddressAPI(payload);
      if (response?.status) {
        onLoad();
      }
      console.log("Delete response:", response);
    } catch (error) {
      console.error("Error deleting address:", error);
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  console.log({ address });

  return (
    <>
      {address.loading && (
        <div style={{ textAlign: "center" }}>
          <SpinnerComponent />
        </div>
      )}

      {address.noData && (
        <div style={{ textAlign: "center", marginTop: "200px" }}>
          <p> Your account doesn't seems to have address information.</p>
          <p style={{ marginBottom: 30 }}>
            {" "}
            Click on the below button to proceed{" "}
          </p>
          <button
            onClick={handleAddBillingAddress}
            className="btn btn-outline-primary btn-sm"
          >
            Add Shipping Address
          </button>
        </div>
      )}

      {address.addBilling && (
        <>
          <div className="row align-items-center mb-3">
            <div className="col">
              <h2
                style={{
                  fontSize: 20,
                  color: "#3a5deb",
                  margin: 0,
                  marginLeft: 5,
                }}
              >
                Shipping Address
              </h2>
            </div>
            {!address.editingIndex && address.editingIndex !== 0 && (
              <div className="col-auto">
                <button
                  className="btn btn-primary btn-sm"
                  onClick={handleAddShippingBlock}
                >
                  + Add Shipping Address
                </button>
              </div>
            )}
          </div>
          <div class="row">
            {address.shippingInputsList?.map((inputs, index) => (
              <div
                key={index}
                className="border rounded p-3 mb-3 position-relative"
              >
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6>Shipping Address {index + 1}</h6>

                  {index > 0 && (
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleRemoveShippingBlock(index)}
                    >
                      Remove
                    </button>
                  )}
                </div>

                <SimpleFormBuilder
                  inputs={inputs}
                  onDataChange={(values) => {
                    const list = [...address.shippingInputsList];
                    list[index] = values;
                    handleFormDataChange("shippingInputsList", list);
                  }}
                />
              </div>
            ))}
          </div>

          <div className="form-check mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              checked={address.billingSame}
              defaultChecked={address.billingSame}
              id="flexCheckDefault"
              onClick={(e) => handleSameAsBilling(e)}
            />
            <label className="form-check-label" for="flexCheckDefault">
              Billing address same as shipping address
            </label>
          </div>

          {!address.billingSame && (
            <>
              <h2 style={{ fontSize: 20, color: "#3a5deb", marginBottom: 20 }}>
                {" "}
                Billing Address{" "}
              </h2>
              <div class="row">
                <SimpleFormBuilder
                  inputs={address.billingInputs}
                  onDataChange={(values) =>
                    handleFormDataChange("billingInputs", values)
                  }
                />
              </div>
            </>
          )}

          <div className="d-flex justify-content-center">
            <button onClick={handleSaveBilling} className="btn btn-primary">
              Save Address Details
            </button>
          </div>
        </>
      )}

      {address.data && (
        <>
          <div className="mb-3 text-end">
            <button
              className="btn btn-primary btn-sm"
              onClick={handleAddShippingBlock}
            >
              + Add Shipping Address
            </button>
          </div>
          {/* Shipping Address */}
          {address.shipping?.map((ship, index) => (
            <div className="address-card" key={ship.id || index}>
              <div className="address-header">
                <h2>
                  <i className="bi bi-truck"></i>
                  Shipping Address {index + 1}
                  {ship.is_default === 1 && (
                    <span className="badge bg-primary ms-2">Primary</span>
                  )}
                </h2>

                <div className="d-flex gap-2">
                  <button
                    onClick={handleEditAddress(ship, index)}
                    className="edit-btn"
                  >
                    <i className="bi bi-pencil"></i> Edit
                  </button>
                  <button
                    onClick={() => {
                      handleDeleteAddress(ship.id);
                    }}
                    className="btn btn-sm btn-outline-danger"
                  >
                    <i className="bi bi-trash"></i> Delete
                  </button>
                </div>
              </div>

              <div className="address-body">
                <div className="address-row">
                  <span className="label">Company Name:</span>
                  <span className="value">{ship.company_name}</span>
                </div>

                <div className="address-row">
                  <span className="label">GST Number:</span>
                  <span className="value">{ship.gstin_number}</span>
                </div>

                <div className="address-row">
                  <span className="label">Contact Person:</span>
                  <span className="value">{ship.invoice_to}</span>
                </div>

                <div className="address-row">
                  <span className="label">Contact Number:</span>
                  <span className="value">{ship.contact_person_number}</span>
                </div>

                <div className="address-row">
                  <span className="label">Address:</span>
                  <span className="value">
                    {ship.address_line1}, {ship.address_line2}, {ship.city},{" "}
                    {ship.state} - {ship.pincode}
                  </span>
                </div>
              </div>
            </div>
          ))}

          {/* Billing Address */}
          <div className="address-card">
            <div className="address-header">
              <h2>
                <i className="bi bi-receipt"></i> Billing Address
              </h2>

              <button onClick={handleEditAddress} className="edit-btn">
                <i className="bi bi-pencil"></i> Edit
              </button>
            </div>

            <div className="address-body">
              <div className="address-row">
                <span className="label">Company Name:</span>
                <span className="value">{address.billing?.company_name}</span>
              </div>

              <div className="address-row">
                <span className="label">GST Number:</span>
                <span className="value">{address.billing?.gstin_number}</span>
              </div>

              <div className="address-row">
                <span className="label">Contact Person:</span>
                <span className="value">{address.billing?.invoice_to}</span>
              </div>

              <div className="address-row">
                <span className="label">Contact Number:</span>
                <span className="value">
                  {address.billing?.contact_person_number}
                </span>
              </div>

              <div className="address-row">
                <span className="label">Address:</span>
                <span className="value">
                  {address.billing?.address_line1},{" "}
                  {address.billing?.address_line2}
                  {address.billing?.city}, {address.billing?.state} -{" "}
                  {address.billing?.pincode}
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default BillingDetailsComponent;
